
const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback, context) => {
    if (!value || !value.trim()) {
        callback(new Error('标题不能为空'));
        return;
    }

    const splitArr = value.split('');
    const totalNum = splitArr.length;
    // 1. 字符数不能超过 60
    if (totalNum > 60) {
        callback(new Error('字符数不能超过 60'));
        return;
    }
    // 2. 至少含 1 个有效字符（中文/英文字母/数字）
    if (!/[\u4e00-\u9fa5a-zA-Z0-9]/.test(value)) {
    // if (!/[a-zA-Z0-9]/.test(value) || !/[\u4e00-\u9fa5]/.test(value)) {
        callback(new Error('标题至少包含 1 个有效字符（中文/英文字母/数字）'));
        return;
    }
    // 3. 不得仅为数字或英文
    if (!/[^a-zA-Z0-9]/.test(value)) {
        callback(new Error('标题不得仅为数字或英文'));
        return;
    }
    // 4 必须包含中文
    if (!/[\u4e00-\u9fa5]/.test(value)) {
        callback(new Error('必须包含中文字符'));
        return;
    }

    // 5. 不得含非法字符，允许的字符集：
    // 中文、英文字母、数字
    // 特殊字符：·~～!@#$%^&()！@#￥%……&*（）-_——=+[]\【】、{}|｜;'；':" "''",./，。、<>?《》？
    // 空格：
    const legalChars = /^[\u4e00-\u9fff\u3400-\u4dbf a-zA-Z0-9·~～!@#$%^&()！@#￥%……&*（）\-_——=+[\]\\【】、{}|｜;'；’:"：‘“”,./，。、<>?《》？\u00A0\u0020\u3000]+$/;
    if (!legalChars.test(value)) {
        callback(new Error('标题包含非法字符'));
        return;
    }

    callback();
}
const validateSubTitle = (rule, value, callback, context) => {

    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    const splitArr = (value || '').split('')
    // let totalNum = 0
    // splitArr.forEach(s => {
    //     totalNum += /[一 - 龥]/.test(s) ? 2 : 1
    // })
    let totalNum = splitArr.length;
    if (totalNum > 18) {
        callback(new Error('字符数不能超过 18'))
    } else if (regx.test(value)) {
        callback(new Error('不能含 emoj 表情'));
    } else {
        callback();
    }
}
const validateHeadImgs = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum < 3) {
        callback(new Error('至少要选择 3 张图片'));
    } else if (sum > 9) {
        callback(new Error('图片数量需小于等于 9 张'));
    } else if (context.$refs.headImgs) {
        let errMsg = await context.$refs.headImgs.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }

}
const validateQualifications = async (rule, value, callback, context) => {
    if (context.$refs.qualifications) {
        let errMsg = await context.$refs.qualifications.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }
}


const validateDescInfo = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum > 50) {
        callback(new Error('图片数量需小于等于 50 张'));
    } else if (context.$refs.descInfo) {
        let errMsg = await context.$refs.descInfo.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else  {
        callback()
    }

}
const validateWeight = (rule, value, callback, context) => {
    const needWeight = Object.values(context.shipsValue || {}).find(item => item.templateId && item.valuationType === 'WEIGHT')
    if(needWeight && !value) {
        callback(new Error('重量必填'));
    }
    callback()
}


// 若需要 vm 上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目'},
            {validator: validateCategoryIds}
        ],
        headImgs: [
            {required: true, message: '至少选择 3 张图片'},
            {validator: contextWrap(validateHeadImgs, context)}
        ],
        qualifications: [
            {validator: contextWrap(validateQualifications, context)}
        ],
        descInfo: [
            {validator: contextWrap(validateDescInfo, context)}
        ],
        title: [
            {required: true, message: '请输入商品名称'},
            {validator: contextWrap(validateTitle, context)},
        ],
        subTitle: [
            {validator: contextWrap(validateSubTitle, context)},
        ],
        weight: [
            {validator: contextWrap(validateWeight, context)},
        ],
    };
}


export {
    RULES as default,
}
